export default __webpack_public_path__ + "static/media/frames_20x20.44a08493.jpg";